import '../assets/styles/fonts.css';
import './Global/Environment';

import { documentLoadContext } from './Global/Tracer';
import { context } from '@opentelemetry/api';
import { bootstrap } from './bootstrap';

documentLoadContext
  .then((ctx) =>
    context.with(ctx, () => {
      bootstrap('root');
    }),
  )
  .catch((err) => {
    console.log(err);
  });
